import { formatAmount } from './withdrawConstants';

function InfoItem({ label, value }) {
  return (
    <p className="kyc-audit-info__item">
      <span className="kyc-audit-info__label">{label}：</span>
      <span>{value ?? '—'}</span>
    </p>
  );
}

/**
 * 提現手續費詳情（唯讀）。
 */
export default function WithdrawFeeDetailModal({ open, row, onClose }) {
  if (!open || !row) {
    return null;
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>手续费详情</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body">
          <div className="kyc-audit-info">
            <InfoItem label="申請金額" value={formatAmount(row.amount)} />
            <InfoItem label="平台手續費" value={formatAmount(row.fee)} />
            <InfoItem label="三方手續費" value={formatAmount(row.thirdFee)} />
            <InfoItem label="提現金額" value={formatAmount(row.withdrawalAmount)} />
            <InfoItem label="到帳金額" value={formatAmount(row.receivedAmount)} />
          </div>
        </div>
        <div className="admin-modal__footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
